
import { MdArrowBack } from "react-icons/md";
import { FiRefreshCw } from "react-icons/fi";
import { RiInformationLine } from "react-icons/ri";
import { Link, NavLink, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import { PiCoins } from "react-icons/pi";
import Popup from "../../../components/popup/Popup";
import {
    showMessage,
    makeAjax,
    url,
    respStatus,
    currencyFormat,
    logoutMe,
} from "../../../helpers/global_helper";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import SidebarMenu from "./SidebarMenu";
import Logo from "../../header/main-header/logo/Logo";
import { getLogout, resetPlayerProfile } from "../../../store/actions";
import { resetPinStatus } from "../../../store/check-pin-status/actions";
import ErrorBoundary from "../../../helpers/ExceptionHandler/componentException";

const SideBar = (props) => {

    const navigate = useNavigate();
    const navigate2 = useNavigate();

    let token = window.localStorage.getItem("user_token");
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();

    const { userProfile, playerMenu, componentSetting } = useSelector((state) => ({
        userProfile: state.playerProfileR?.data ?? {},
        playerMenu: state.menuListR.data,
        componentSetting: state.componentSettingListR.data,
    }));

    const [playerBalance, setPlayerBalance] = useState([]);
    const [spinning, setSpinning] = useState(false);
    const [openMenu, setOpenMenu] = useState([]);
    const [loggedIn, setLoggedIn] = useState('');
    const [isComingSoon, setComingSoon] = useState(false);
    const [promotionCategory, setPromotionCategory] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [bankDetailSet, setBankDetailSet] = useState(false);


    const handleClose = (code) => {
        props.sideBarClose();
        setBankDetailSet(false);
        setOpenMenu([]);
        if (code) {
            if (code == 'hkb-transactions') {
                props.handlePopup();
                return;
            }
            navigate(`/${code}`);
        }
    };

    const loginPopup = () => {
        props.loginPopupTrigger();
        props.sideBarClose();
    };

    const handleOutsideClick = (e) => {
        if (props.sideRef.current && !props.sideRef.current.contains(e.target)) {
            setOpenMenu([]);
        }
    };

    const handleRefreshBalance = () => {
        makeAjax(url.GP_API.getBalance, "", url.GP_MS_EXT).then((response) => {
            if (response.status != respStatus["SUCCESS"]) {
                if (response.code != "validation_error") {
                    showMessage(response);
                    return;
                }
                showMessage(response);
                return;
            }
        });
        fetchPlayerBalance();
        setSpinning(true);
        setTimeout(() => {
            setSpinning(false);
        }, 1000);
    };

    const fetchPlayerBalance = () => {
        makeAjax(url.GP_API.getBalance, [], url.GP_MS_EXT).then((response) => {
            if (response.status != respStatus["SUCCESS"]) {
                showMessage(response);
                return;
            }
            setPlayerBalance(response.data);
        });
    };

    const handleIconClick = () => {
        makeAjax(url.ADMIN_API.promotionCategoryNameDD, [], url.ADMIN_MS_EXT).then(
            (response) => {
                if (response.status != respStatus["SUCCESS"]) {
                    return;
                }
                setPromotionCategory(response.data);
            }
        );
        setIsClicked(!isClicked);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsClicked(false);
        }
    };

    const pushMenu = (menuName) => {
        const selectedMenu = [...openMenu];
        const index = selectedMenu.indexOf(menuName);

        if (index === -1) {
            selectedMenu.push(menuName);
        } else {
            selectedMenu.splice(index, 1);
        }
        setOpenMenu(selectedMenu);
    }



    useEffect(() => {
        if (loggedIn) {
            fetchPlayerBalance();
        }
        if (userProfile && userProfile?.player_bank_detail != null) {
            setBankDetailSet(true);
        }
    }, [userProfile]);

    useEffect(() => {
        setLoggedIn(token);
    }, [token])

    useEffect(() => {
        if (loggedIn != "" && loggedIn != null) {
            fetchPlayerBalance();
        }

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener("click", handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);


    const logout = () => {
        logoutMe();
    };



    return (
        <>
            <div
                className={`side-bar background-mobile_side_bar ${props.sideBar ? "show" : ""}`}
                ref={props.sideRef}
            >
                <div className="login-btns">
                    <div className="close" onClick={() => handleClose()}>
                        <MdArrowBack />
                    </div>
                    <div className={`user-btns ${loggedIn ? 'user-btns-center' : ''}`}>
                        {loggedIn ? (
                            <>
                                <div className="menu-title"></div>
                                {/* <div className="postlogin-btns">
                                    <Link to={bankDetailSet ? '/withdraw' : '/bank-details/withdraw'}  className="with-btn" onClick={() => handleClose()}>
                                        {props.t("withdraw")}
                                    </Link>
                                    <Link className="depo-btn" to={bankDetailSet ? '/deposit' : '/bank-details/deposit'} onClick={() => handleClose()}>
                                        {props.t("deposit")}
                                    </Link>
                                </div> */}
                                <div className="user-details">
                                    <div className="user-name-icon">
                                        <div className="user-icon">
                                            <span className="usr-profle">
                                                {userProfile.username
                                                    ? userProfile.username[0].toUpperCase()
                                                    : "U"}
                                            </span>
                                        </div>
                                        <div>
                                            <span className="welcome-profile">{props.t('welcome')},</span>
                                            <h4 className="title">
                                                {userProfile.username}</h4>
                                            <div className="idr-info">
                                                <span className="idr-num idr">
                                                    {userProfile ? userProfile.currency : ""}{" "}
                                                    <>{currencyFormat(Math.round(playerBalance?.main_balance)) ?? 0}</>
                                                    <div className="side-refresh">
                                                        <a className="spin-iconbtn">
                                                            <FiRefreshCw
                                                                onClick={() => {
                                                                    handleRefreshBalance();
                                                                }}
                                                                className={`spin-button ${spinning ? "spin" : ""}`}
                                                            />
                                                        </a>{" "}
                                                    </div>
                                                </span>


                                                <div className="d-flex balance-chip">
                                                    <div className="chip-img">
                                                        <PiCoins className="coins" />
                                                    </div>
                                                    <div className="chip-amount">
                                                        {currencyFormat(playerBalance?.promo_balance) ?? 0}
                                                    </div>
                                                    {/* <div className="iconhoverdiv" ref={dropdownRef}>
                                                <div className="icon d-flex" onClick={handleIconClick} >
                                                    <RiInformationLine className="infohover-icon" />
                                                </div>
                                            </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sidebar-details-btn">
                                        <NavLink className="view-profile-btn text_button-view_profile" to={"profile"} onClick={() => { props.sideBarClose() }}>
                                            {props.t("view_profile")}
                                        </NavLink>
                                        <NavLink
                                            to={'/'}
                                            className="logout-btn text_button-logout_mobile background-logout_mobile border-logout_mobile"
                                            onClick={() => { logout() }}
                                        >
                                            {props.t('logout')}
                                        </NavLink>
                                    </div>
                                </div>


                            </>
                        ) : (
                            <>
                                {typeof componentSetting?.["top-nav-login-box"] !=
                                    "undefined" &&
                                    componentSetting?.["top-nav-login-box"]?.[
                                    "default-value"
                                    ] && (
                                        <>
                                            {/* <div className="signup-btns">
                                                <button className="login" onClick={loginPopup}>
                                                    {props.t("login")}
                                                </button>
                                                <NavLink
                                                    to="register"
                                                    className="register"
                                                    onClick={() => handleClose()}
                                                >
                                                    {props.t('register')}
                                                </NavLink>
                                            </div> */}
                                            <div className="signup-grid-btns">
                                                <ErrorBoundary>
                                                    <Logo />
                                                </ErrorBoundary>
                                                <div className="main-regi">
                                                    <NavLink
                                                        to="register"
                                                        className="register text-sidebar_register border-sidebar_register"
                                                        onClick={() => handleClose()}
                                                    >
                                                        {props.t('register')}

                                                    </NavLink>
                                                    <NavLink onClick={loginPopup} className="login">
                                                        {props.t("already_have_an_account")}  <span>{props.t("login")}</span>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </>
                                    )}
                            </>
                        )}
                    </div>
                </div>

                {isClicked &&
                    promotionCategory
                    && promotionCategory !== null
                    && playerBalance.promo_balance > 0 && (
                        <div className="click-content">
                            <p>{props.t("following_categories_are_applicable_for_promos")}</p>
                            <ul>
                                {promotionCategory &&
                                    promotionCategory !== null &&
                                    promotionCategory.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                            </ul>
                        </div>
                    )}
                <ErrorBoundary><SidebarMenu sideBarClose={props.sideBarClose} handleClose={handleClose} /></ErrorBoundary>
            </div >


            <div className={`overlay ${props.sideBar ? "show" : ""}`}></div>
        </>
    );
};

SideBar.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(SideBar);
